import * as React from 'react';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { IBoardCardAgingSectionProps } from './types';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { CardAgingHOC } from '../../hocs/CardAgingHOC/CardAgingHOC';
import {
    CARD_AGING_MODAL_CANCEL,
    CARD_AGING_MODAL_REMOVE,
    CARD_AGING_MODAL_TEXT,
    CARD_AGING_MODAL_TITLE,
    DETAILS_SECTION_CARD_AGING_PROPERTIES
} from '../../constants';
import { CardAgingTogglerHOC } from '../../hocs/CardAgingTogglerHOC/CardAgingTogglerHOC';
import { ActionModal } from '../../../../../../base/components/ActionModal/ActionModal';
import {
    EssentialUpgradeButtonHOC
} from '../../../../../../base/components/EssentialUpgradeButton/hocs/EssentialUpgradeButtonHOC/EssentialUpgradeButtonHOC';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';

export function CardAgingSection ({
    isEssentialFeature,
    onChange,
    onShowBoardLimitSnackbarIfNeeded,
    onClose
}: IBoardCardAgingSectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--card-aging';
    const [isShow, setShow] = React.useState(null);
    const onCloseModal = () => {
        onClose();
        setShow(false);
    };
    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.CARD_AGING} />
            <SettingsSection
                className={className}
                title={DETAILS_SECTION_CARD_AGING_PROPERTIES}
                isEssentialFeature={isEssentialFeature}
                titleButton={
                    <CardAgingTogglerHOC
                        boardId={boardId}
                        onChange={() => onChange().then(result => {
                            if (!result) setShow(true);
                        })}
                        onClickDisabled={onShowBoardLimitSnackbarIfNeeded}
                    />
                }
            >
                <CardAgingHOC
                    boardId={boardId}
                />
                <ActionModal
                    isShow={isShow}
                    actions={[
                        {
                            variant: 'primary',
                            onClick: onCloseModal,
                            children: CARD_AGING_MODAL_CANCEL
                        },
                        {
                            variant: 'secondary',
                            onClick: () => {
                                onCloseModal();
                                onChange();
                            },
                            children: CARD_AGING_MODAL_REMOVE
                        },
                    ]}
                    footer={<EssentialUpgradeButtonHOC onClick={onCloseModal} />}
                    text={CARD_AGING_MODAL_TEXT}
                    title={CARD_AGING_MODAL_TITLE}
                    onClose={onCloseModal}
                />
            </SettingsSection>
        </>
    );
};
